/* eslint-disable class-methods-use-this */
import Vue from 'vue';
import GstplnApp, { GstplnAppCategory } from '../app';

export default class LightspeedApp extends GstplnApp {
  constructor(vue: Vue) {
    super(vue, 'app.lightspeed-lseries', {
      categories: [GstplnAppCategory.Pos],
      underPaywall: true,
      hasDarkIcon: true,
      configComponentImportFnc: () => import('@/components/apps/lightspeed-lseries/SettingsDialog.vue'),
    });
  }
}
